export const FORM_STEPS = [
  "PERSONAL_INFO",
  "EDUCATION",
  "EXPERIENCE",
  "SKILLS",
  "CONFIGURATION",
];
